<section class="card cursor-pointer !p-3 !gap-2 !flex-row">
  @if (toastService.icon) {
    <span
      class="material-symbols-rounded"
      [style.color]="toastService.iconColor || 'rgba(0,0,0,.6)'"
      >{{ toastService.icon || 'save' }}</span
    >
  }
  <div class="flex-1">
    <h3 class="leading-6 mb-1">{{ toastService.title }}</h3>
    <span class="text-black/60">{{ toastService.message }}</span>
  </div>
  <span
    class="material-symbols-rounded cursor-pointer"
    (click)="toastService.hide()"
    >close</span
  >
</section>
